import React from "react";

export default function StreakModal({ onClose, streakInfo }) {
  const streak = streakInfo?.currentStreak || 0;
  const highest = streakInfo?.highestStreak || 0;

  return (
    <div className="p-8 text-center">
      <div className="text-7xl mb-6">🔥</div>
      <h2 className="text-4xl font-bold text-[#2B2140] mb-2">{streak}</h2>
      <p className="text-xl text-gray-600 mb-6">Day Streak</p>

      {highest > 0 && (
        <p className="text-sm text-[#8B7FA8]">Best streak: {highest} days</p>
      )}

      <button 
        onClick={onClose}
        className="mt-10 w-full py-4 bg-[#7C3AED] text-white font-semibold rounded-2xl text-lg"
      >
        Close
      </button>
    </div>
  );
}